import { FC, useEffect, useState } from 'react'
// import './styles.scss'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'
import ContentGrid from 'components/ContentGrid'
import {
  ContentWidth,
  TextWidth,
  TextWidthExtended,
  TextWidthExtendedFullMobile,
  ArticleWidth,
} from '@ta-interaktiv/react-disco-grid'
// import {
//   ContentWidth,
//   Left,
//   LeftAndText,
//   Right,
//   RightAndText,
//   TextWidth,
//   TextWidthExtended,
// } from 'components/Container'

export const ImageSwitch: FC<{
  mobileImageUrl?: string
  desktopImageUrl?: string
  mobileImageUrlDark?: string
  desktopImageUrlDark?: string
  colorMode: 'dark' | 'light' | undefined
  title?: string
  lead?: string
  width?:
    | 'full'
    | 'content'
    | 'text'
    | 'textfullmobile'
    | 'textextended'
    | 'textextendedfullmobile'
    | 'article'
  caption?: string
  source?: string
  labelType?: 'top' | 'bottom'
}> = ({
  mobileImageUrl,
  desktopImageUrl,
  mobileImageUrlDark,
  desktopImageUrlDark,
  colorMode,
  title,
  lead,
  width,
  caption,
  source,
  labelType = 'top',
}) => {
  const windowSize = useWindowSize()
  const [isMobile, setIsMobile] = useState(false)
  useEffect(() => {
    setIsMobile(windowSize.width < 712)
  }, [windowSize.width])

  const imageurlmob =
    colorMode === 'dark' && mobileImageUrlDark
      ? mobileImageUrlDark
      : mobileImageUrl

  const imageurldesk =
    colorMode === 'dark' && desktopImageUrlDark
      ? desktopImageUrlDark
      : desktopImageUrl

  return (
    <>
      {(title || caption) && labelType === 'top' && (
        <TextWidth>
          <Header>
            {title && <Title>{title}</Title>}
            {lead && <Lead>{lead}</Lead>}
          </Header>
        </TextWidth>
      )}

      {width === 'full' && (
        <Image
          isMobile={isMobile}
          mobile={imageurlmob}
          desktop={imageurldesk}
        />
      )}
      {width === 'content' && (
        <ContentWidth>
          <Image
            isMobile={isMobile}
            mobile={imageurlmob}
            desktop={imageurldesk}
          />
        </ContentWidth>
      )}
      {width === 'text' && (
        <TextWidth>
          <Image
            isMobile={isMobile}
            mobile={imageurlmob}
            desktop={imageurldesk}
          />
        </TextWidth>
      )}
      {width === 'textfullmobile' && (
        <TextFullMobile>
          <Image
            isMobile={isMobile}
            mobile={imageurlmob}
            desktop={imageurldesk}
          />
        </TextFullMobile>
      )}
      {width === 'textextended' && (
        <TextWidthExtended>
          <Image
            isMobile={isMobile}
            mobile={imageurlmob}
            desktop={imageurldesk}
          />
        </TextWidthExtended>
      )}
      {width === 'textextendedfullmobile' && (
        <TextWidthExtendedFullMobile>
          <Image
            isMobile={isMobile}
            mobile={imageurlmob}
            desktop={imageurldesk}
          />
        </TextWidthExtendedFullMobile>
      )}
      {width === 'article' && (
        <ArticleWidth>
          <Image
            isMobile={isMobile}
            mobile={imageurlmob}
            desktop={imageurldesk}
          />
        </ArticleWidth>
      )}

      {(caption || source) && (
        <TextWidth>
          <>
            {labelType === 'bottom' && (
              <>{title && <Title className='bottom'>{title}</Title>}</>
            )}
          </>
          <Caption className={labelType === 'top' ? 'top' : ''}>
            {(labelType === 'bottom' || labelType === 'top') && caption}
            {source && <Source>{source}</Source>}
          </Caption>
        </TextWidth>
      )}
    </>
  )
}

const Image = ({
  mobile,
  desktop,
  isMobile,
}: {
  mobile?: string
  desktop?: string
  isMobile: boolean
}) => {
  return (
    <ImageContainer className='ImageContainer'>
      {mobile && desktop ? (
        <img src={isMobile ? `${mobile}` : `${desktop}`}></img>
      ) : mobile ? (
        <img src={mobile}></img>
      ) : (
        <img src={desktop}></img>
      )}
      {}
    </ImageContainer>
  )
}
{
  /* <video
          ref={vidRef}
          controls
          // autoPlay
          muted
          playsInline
          loop
          poster={isMobile ? mobilePoster : desktopPoster}
        >
          {isMobile && <source src={`${mobileVideo}`} type='video/mp4' />}
          <source src={`${desktopVideo}`} type='video/mp4' />
        </video> */
}
const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  gap: 20px;
`
const Title = styled.h3`
  color: var(--text-color);
  margin: 0;
  font-size: 18px !important;
  line-height: 2.4rem;
  margin-bottom: 20px;

  &.bottom {
    margin-top: 1.5rem;
    font-size: 1.5rem !important;
    line-height: 2.1rem;
    margin-bottom: 0;
  }
`
const Lead = styled.div`
  color: var(--text-color);
  font-size: 15px;
  width: 100%;
  font-style: normal;
  font-weight: 400;
  line-height: 2.3rem;
  margin: 0;
  margin-bottom: 1rem;
  &.bottom {
    line-height: 2.1rem;
    margin-bottom: 0;
  }
`

const TextFullMobile = styled(TextWidth)`
  @media screen and (max-width: 767px) {
    margin-left: -2rem;
    width: calc(100% + 4rem);
    max-width: calc(100% + 4rem);
  }
`

const Caption = styled.figcaption`
  color: var(--text-color);
  font-family: var(--font-sans-serif);
  font-size: 1.5rem;
  line-height: 2.1rem;

  &.top {
    margin-top: 1.5rem;
  }

  .source {
    margin-top: 0.5em;
    font-weight: 400;
    color: var(--gray-3);
    font-size: 1.2rem;
    line-height: 1.8rem;
  }
`
const Source = styled.div`
  margin-top: 0.5em;
  font-weight: 400;
  color: var(--gray-3);
  font-size: 1.2rem;
  line-height: 1.8rem;
  &.bottom {
    margin-top: 0.3rem;
  }
`
const ImageContainer = styled.div<{ tenant?: string }>`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  grid-column: 1/-1;
  width: 100%;
  img {
    width: 100%;
    height: auto;
  }
`
